

const MenuDesktop = () => (
  <nav>
    <ul className="list-unstyled d-flex">
      <li className="me-4">
        <a href="#pratice-areas" className="text-decoration-none light-text-color">
          Practice areas
        </a>
      </li>
      <li className="me-4">
        <a href="#pratice-advice" className="text-decoration-none light-text-color">
          Practice advice
        </a>
      </li>
      <li className="me-4">
        <a href="#who-we-are" className="text-decoration-none light-text-color">
          Who we are
        </a>
      </li>
      <li className="me-4">
        <a href="#contact-us" className="text-decoration-none light-text-color">
          contact us
        </a>
      </li>
    </ul>
  </nav>
);

export default MenuDesktop;
